import { connect } from 'react-redux';

import TopicDistribution from './TopicDistribution';

const mapStateToProps = (state) => ({
  lang: state?.state?.lang,
});

export default connect(mapStateToProps)(TopicDistribution);
